import React from "react";
import {FormComponent} from "../../components/FormComponent";
import {Loader} from "../../components/Loader";
import {FormSubmit} from "../../components/FormComponent/FormSubmit";
import {FormGroup} from "../../components/FormComponent/FormGroup";

export class CreateLinguisticValue extends FormComponent {
    protected needMount: boolean = false;

    protected getRequestUrl(): RequestInfo | URL {
        return '/linguistic-values/save';
    }

    protected onSuccess(data: any, event: React.FormEvent | null): any {

        //@ts-ignore
        const namespace = document.querySelector('#namespace').value || 'frontend';
        //@ts-ignore
        const key = document.querySelector('#key').value || 'unknown';

        window.location.assign(`/linguistic-values/edit/${namespace}/${key}`);
    }

    render() {
        if (this.needMount && this.state === null) {
            return <Loader/>;
        }

        const
            dictionary = this.dictionary,
            state = this.state;

        return (
            <>
                <form className="x-form" onSubmit={this.handleSubmit}>

                    <input type="hidden" name="key"/>

                    <div className="row justify-content-center">

                        <div className="col-md-12 col-lg-10 col-xl-8 col-xxl-6">
                            <br/>&nbsp;
                            <h5>{dictionary.get['edit-linguistic-values']}</h5>

                            <FormGroup.Select {...{
                                id: 'namespace',
                                required: true,
                                items: ['frontend', 'auth', 'backend'],
                                defaultValue: state?.namespace || 'frontend'
                            }}/>

                            <FormGroup.Input {...{
                                id: 'key',
                                required: true,
                                readOnly: !!state?.key,
                                defaultValue: state?.key || ''
                            }}/>

                            <div className="linguistic-values-holder">
                                {dictionary.handledLanguages.map(function (language) {
                                    const id = `value-${language}`, name = `value_${language}`;
                                    return (
                                        <FormGroup.Input key={id} {...{
                                            id: id,
                                            name: name,
                                            labelText: dictionary.get['linguistic-value'] + ` - ` + dictionary.get[language] + ` (${language})`,
                                            required: dictionary.languages.includes(language),
                                            defaultValue: state?.values[language] || ''
                                        }}/>
                                    )
                                })}
                            </div>

                            <FormSubmit/>
                        </div>
                    </div>
                </form>

            </>
        );
    }
}